import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '@ncl/assets/styles/bootstrap.custom.scss';
// import 'bootstrap/dist/css/bootstrap-grid.min.css';

import { FadeIn } from '@ncl/modules/shared/components';
import { PanelHeader, BoxWithMargin } from 'components-core';

import {
  SpanLight,
  SpanVeryLight,
  SpanHeavy,
  Title,
  MediunTitle,
  StyledFont,
  Section,
  BorderedSection,
  ListSection,
  ButtonLeft,
  CenterButton,
} from './CrossJudicialStyle';

const CrossJudicial = ({ history }) => {
  function redirectToQuote() {
    history.push('/cotacao/fase-da-acao');
  }

  return (
    <FadeIn>
      <PanelHeader />
      <Container fluid="md">
        <Row>
          <Col>
            <Title>Recupere os recursos da sua empresa imobilizados na Justiça do Trabalho.</Title>
          </Col>
        </Row>

        <BoxWithMargin responsive={{ bottom: '30px' }} desktop={{ bottom: '50px' }}>
          <Row>
            <Col md={9}>
              <SpanLight>
                Para ajudar as empresas nesse momento de crise, o Conselho Nacional de Justiça (CNJ)
                autorizou a substituição dos recursos retidos em depósitos judiciais e penhora de
                bens por apólices de Seguro Garantia Judicial.
              </SpanLight>
            </Col>
          </Row>
        </BoxWithMargin>

        <BoxWithMargin responsive={{ bottom: '30px' }} desktop={{ bottom: '30px' }}>
          <Row>
            <Col sm={5}>
              <SpanHeavy>
                Faça uma cotação do <br />
                Seguro Garantia Judicial Trabalhista.
              </SpanHeavy>
            </Col>
          </Row>
        </BoxWithMargin>

        <BoxWithMargin responsive={{ bottom: '40px' }} desktop={{ bottom: '84px' }}>
          <Row>
            <Col>
              <ButtonLeft
                variant="primary"
                size="big"
                onClick={redirectToQuote}
                data-testid="next-button"
              >
                Simule agora
              </ButtonLeft>
            </Col>
          </Row>
        </BoxWithMargin>

        <Section>
          <Row>
            <Col>
              <MediunTitle>Como funciona</MediunTitle>
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={4}>
              <BoxWithMargin responsive={{ bottom: '20px' }}>
                <ListSection>
                  <Row>
                    <Col xs={2} md={2} sm={1}>
                      <StyledFont>1</StyledFont>
                    </Col>
                    <Col>
                      <SpanLight>
                        Contrate uma apólice de Seguro Garantia por uma fração do valor do depósito
                        ou penhora.
                      </SpanLight>
                    </Col>
                  </Row>
                </ListSection>
              </BoxWithMargin>
            </Col>

            <Col xs={12} md={4}>
              <BoxWithMargin responsive={{ bottom: '20px' }}>
                <ListSection>
                  <Row>
                    <Col xs={2} md={2} sm={1}>
                      <StyledFont>2</StyledFont>
                    </Col>
                    <Col>
                      <SpanLight>
                        Apresente a apólice na vara ou tribunal em que a reclamatória está sendo
                        julgada.
                      </SpanLight>
                    </Col>
                  </Row>
                </ListSection>
              </BoxWithMargin>
            </Col>

            <Col xs={12} md={4}>
              <BoxWithMargin responsive={{ bottom: '20px' }}>
                <ListSection>
                  <Row>
                    <Col xs={2} md={2} sm={1}>
                      <StyledFont>3</StyledFont>
                    </Col>
                    <Col>
                      <SpanLight>
                        A apólice passa a ser a garantia no processo e sua empresa recupera os
                        recursos.
                      </SpanLight>
                    </Col>
                  </Row>
                </ListSection>
              </BoxWithMargin>
            </Col>
          </Row>

          <Row>
            <Col md={9} sm={9} xs={12}>
              <BoxWithMargin
                responsive={{ bottom: '10px', top: '20px;' }}
                desktop={{ top: '40px', bottom: '50px' }}
              >
                <SpanVeryLight>
                  O seguro garantia não isenta a empresa de suas obrigações com a Justiça do
                  Trabalho ao fim do trâmite do processo. Ele é uma ferramenta para a empresa
                  desbloquear recursos durante as reclamatórias trabalhistas.
                </SpanVeryLight>
              </BoxWithMargin>
            </Col>
          </Row>
        </Section>
      </Container>

      <BorderedSection />

      <Container>
        <BoxWithMargin
          responsive={{ top: '8px', bottom: '70px' }}
          desktop={{ top: '15px', bottom: '40px' }}
        >
          <Row>
            <Col md={7} sm={9} xs={12}>
              <MediunTitle>Faça uma cotação e converse com seu advogado.</MediunTitle>
            </Col>
            <Col xs={1} />
            <Col md={4} sm={12} xs={12} style={{ 'align-self': 'center' }}>
              <CenterButton
                variant="primary"
                size="big"
                onClick={redirectToQuote}
                data-testid="next-button"
              >
                Simule agora
              </CenterButton>
            </Col>
          </Row>
        </BoxWithMargin>
      </Container>
    </FadeIn>
  );
};

export default CrossJudicial;
